













import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({ type: String, required: false, default: 'button' }) private type!: string;
  @Prop({ type: [Object, String], required: false, default: null }) private link!: object | string;
  @Prop({ type: Boolean, required: false, default: false }) private disabled!: boolean;
}
